import { useEffect, useState } from 'react';
import Router from './components/Router';
import { useModal } from './common/context/ModalProvider';
import Modal from './components/Modal';
import { Flip, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from './components/loaders/Loader';
import { useGlobal } from './common/context/GlobalProvider';
import storage from './common/Storage';
import { useAuth } from './common/context/AuthProvider';
import { useNavigate } from 'react-router';
import Installation from './components/Installation';
import DialogContainer from './components/DialogContainer';
import ConfirmDialog from './components/ConfirmDialog';
import DrawerContainer from './components/DrawerContainer';
import { Drawer } from './components/ui/drawer';
import { useDialog } from './common/hooks/useDialog';
import DesktopWarning from './components/DesktopWarning';
import useLoadUserFromLocalStorage from './common/hooks/useLoadUserFromLocalStorage';
import ScreenLoader from './components/loaders/ScreenLoader';

function App() {
  const { isModalOpen } = useModal();
  const { drawerContent, closeDrawer } = useDialog();
  const { isLoading, isDarkMode } = useGlobal();
  const { isLocalStorageLoaded } = useLoadUserFromLocalStorage();

  if (document.documentElement.clientWidth > 500) {
    return <DesktopWarning />;
  }

  if (!isLocalStorageLoaded) {
    return <ScreenLoader />;
  }

  // if (!window.matchMedia('(display-mode: standalone)').matches) {
  //   return <Installation />;
  // }

  return (
    <div
      className={` overflow-hidden touch-none w-[100vw] transition-all duration-300 bg-black ${
        isModalOpen ? 'p-3' : ' '
      }  ${isDarkMode && 'dark'}`}
    >
      <main
        className={`bg-white dark:bg-black w-full h-full overflow-hidden transition-all duration-300 ${
          isModalOpen ? ' rounded-lg' : ' rounded-none'
        } `}
      >
        <Drawer onClose={closeDrawer} open={drawerContent['opened']}>
          <Router />
          <DrawerContainer />
        </Drawer>

        <Modal />
        <DialogContainer />
        <ConfirmDialog />
        <ToastContainer
          position='top-center'
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          limit={1}
          theme='colored'
          className='!p-3 '
          transition={Flip}
        />
        {isLoading && <Loader />}
      </main>
    </div>
  );
}

export default App;
